/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_EmptyInputs */

const en_control_planner_empty = /** @type {(inputs: Control_Planner_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose abilities to start your plan.`)
};

const zh_control_planner_empty = /** @type {(inputs: Control_Planner_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未选择`)
};

/**
* | output |
* | --- |
* | "Choose abilities to start your plan." |
*
* @param {Control_Planner_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_empty = /** @type {((inputs?: Control_Planner_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_empty(inputs)
	return zh_control_planner_empty(inputs)
});
export { control_planner_empty as "control.planner.empty" }